'use strict';
var $ = jQuery;

(function ($) {

    /*  Hide broken image icon */
	$("img").on("error", function() {
		$(this).hide();
	});
       
    $(document).ready(function(){
         $(".content, .quote-banner, .image-banner").fadeTo(1000, 1);
    });
   

})(jQuery);
